import type MainProject from '@/model/MainProject'

/** 强制存读档有效存档号下限。 */
export const FORCED_SAVE_READ_SLOT_MIN = 1

/** 未配置最大存档数时的兜底上限（与设置草稿 `createSaveLoadDraft` 一致）。 */
export const FORCED_SAVE_READ_SLOT_DEFAULT_MAX = 6

/**
 * 读取强制存读档存档号上限：取设置中存读档的最大存档数。
 * @param project 当前工程；未传或 Max 无效时使用 {@link FORCED_SAVE_READ_SLOT_DEFAULT_MAX}。
 */
export function readForcedSaveReadSlotMax(project?: MainProject | null): number {
  const raw = Math.round(Number(project?.systemData?.Sldata?.Max) || 0)
  const max = raw > 0 ? raw : FORCED_SAVE_READ_SLOT_DEFAULT_MAX
  return Math.max(FORCED_SAVE_READ_SLOT_MIN, max)
}

/**
 * 将强制存读档存档号限制在 1~最大存档数。
 * @param value 原始存档号
 * @param project 当前工程，用于读取最大存档数
 */
export function clampForcedSaveReadSlot(value: number, project?: MainProject | null): number {
  const max = readForcedSaveReadSlotMax(project)
  const parsed = Math.round(Number(value) || FORCED_SAVE_READ_SLOT_MIN)
  return Math.min(max, Math.max(FORCED_SAVE_READ_SLOT_MIN, parsed))
}

/**
 * 判断强制存读档存档号是否在有效范围内。
 * @param value 存档号
 * @param project 当前工程，用于读取最大存档数
 */
export function isForcedSaveReadSlotValid(value: number, project?: MainProject | null): boolean {
  const max = readForcedSaveReadSlotMax(project)
  return value >= FORCED_SAVE_READ_SLOT_MIN && value <= max
}
